import { useCallback } from "react";
import { useHandleUnauthorized, isManualLogout } from "../token";
import MessageToster from "../component/MessageToster";

export const useHandleError = () => {
    const handleUnauthorized = useHandleUnauthorized();

    const handleError = useCallback((err) => {
        if (!err) return;

        // If user manually logged out, ignore 401s from pending in-flight requests
        if (isManualLogout()) {
            return;
        }

        if (err.response?.status === 401) {
            handleUnauthorized();
            return;
        }
        else if (err.message === "Network Error" || !err.response) {
            MessageToster(
                "error",
                "Unable to connect to server. Please check your network or try again later."
            );
        }
        else {
            const message =
                err.response?.data?.error ||
                err.response?.data?.message ||
                err.response?.data?.msg ||
                err.response?.data?.errors ||
                err.message ||
                "Something went wrong";

            const messageString = typeof message === 'object' ? JSON.stringify(message) : String(message);
            const noDataRegex = /(?:no|not|empty|zero|none)\s+(?:\w+\s+){0,2}(?:data|record|transaction|ticket|open|closed|trade|client|account|history|commission|user|applied|detail|found)/i;
            
            const isSuppressed = messageString.toLowerCase().includes("empty") || noDataRegex.test(messageString);
            const isNotFoundError = err.response?.status === 404;

            if (isNotFoundError || isSuppressed) {
                console.log("Suppressed empty data warning:", message);
                return;
            }

            MessageToster("error", message);
        }
    }, [handleUnauthorized]);

    return handleError;
};
